<template>
    <multiselect
            :options="options"
            :value="value"
            placeholder="Land"
            @input="$emit('input', $event)"
            :searchable="true"
    ></multiselect>
</template>


<script>
    import Multiselect from './Multiselect'

    export default {
        components: {
            Multiselect
        },

        props: ['value'],

        data() {
            return {
                options: [
                    {
                        label: 'Deutschland',
                        value: 'DE'
                    },
                    {
                        label: 'Niederlande',
                        value: 'NL',
                    }
                ]
            }
        }

    }
</script>
